<template>
  <div class="index">
    <div class="index_head">
       <img :src="domain+bgpic" alt="" class="banner">
       <div class="index_head_text">
        <!--  <p>安永复旦<br>最具潜力企业评选</p> -->
       </div>
    </div>
    <div class="index_menu clearfix">
      <div class="menu_item" v-for='item in list' >
        <a :href="item.jumpurl" v-if='item.jumpurl'>
          <div class="item_img">
            <img :src="domain+item.icon">
          </div>
     
        </a>
        <router-link :to="'/'+item.ename+'/index'" v-else>
          <div class="item_img">
            <img :src="domain+item.icon">
          </div>
        </router-link>
      </div>
      <!-- <div class="menu_item">
        <router-link to="/tmbz/index">
          <div class="item_img">
            <i class="icons i2"></i>
          </div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link to="/xmtd/index">
          <div class="item_img">
            <i class="icons i3"></i>
          </div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link to="/tmc/index">
          <div class="item_img">
            <i class="icons i4"></i>
          </div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link to="/bjlsc/index">
          <div class="item_img">
            <i class="icons i5"></i>
          </div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link to="/jchg/index">
          <div class="item_img">
            <i class="icons i6"></i>
          </div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link to="/ljhjqy/index">
          <div class="item_img">
            <i class="icons i7"></i>
          </div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link to="/zxybg/index">
          <div class="item_img">
            <i class="icons i8"></i>
          </div>
        </router-link>
      </div>
      <div class="menu_item">
        <router-link to="/about/index">
          <div class="item_img">
            <i class="icons i9"></i>
          </div>
        </router-link>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      url:'',
      showp:false,
      list:[],
      bgpic:''
    }
  },
  mounted:function(){
     this.getmenus()
    //console.log(swiper)
  },
  methods:{
    getmenus(){
      this.$http.get('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_index',
       {
          
        },
       /*{emulateJSON : true}*/)
   .then((response) => {
        console.log(response)
        this.list = response.body.data;
        this.bgpic = response.body.bgpic
     })
    }
  }
}
</script>

<style scoped>
  .index{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #cbc7c6;
  }
  .banner{
    width: 100%;
    display: block;
  }
  .index_head{
    position: relative;
  }
  .index_head_text{
    width: 3.97rem;
    height: 2.38rem;
    position: absolute;
    font-size: 0.4292rem;
    color: #414042;
    background-image: url(/../../../static/images/yellow_bc.png);
    background-size: cover;
    position: absolute;
    bottom: -0.75rem;
    left: 0.34rem;
    font-weight:500;
  }
  .index_head_text p{
    padding-top: 1rem;
    padding-left: 0.3rem;
    line-height: 0.5rem;
  }
  .index_menu{
    padding:1rem 0.8rem 0.6rem;
    border-top: 0.04rem solid #fff;
    background-color: #ccc7c7;
  }
  .menu_item{
    float: left;
    width: 1.24rem;
    height: 1.24rem;
    border:0.04rem solid #fcd204;
    box-sizing: border-box;
    margin-right: 0.54rem;
    border-radius: 0.2rem 0 0.2rem 0;
    box-shadow: 0.04rem 0.04rem 0.08rem #807d7d;
    text-align: center;
    margin-bottom: 0.28rem;
    background: linear-gradient(135deg, rgb(215,216,217) 0%,rgb(255,255,255) 40%,rgb(255,255,255) 60%,rgb(215,216,217) 100%);
  }
  .menu_item:nth-child(3n){
    margin-right: 0;
  }
  .item_img{
    height: 100%;
    position: relative;
    width: 100%;
  }
  .item_img img{
    width: 1.04rem;
    height: 1.04rem;
    display: block;
    margin: 0 auto;
    margin-top: .1rem;
  }
  .item_img i{
    background-image: url(../../static/images/icons_menu4.png);
    background-size: 4.47rem 3.5rem;
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  i.i1{
    width: 0.80rem;
    height: 1.2rem;
    background-position: -2.34rem -1.1rem;
  }
  i.i2{
    width: 0.83rem;
    height: 1.02rem;
    background-position: -0.1rem -1.24rem;
    bottom: 0.05rem;
  }
  i.i3{
    width: 0.81rem;
    height: 0.92rem;
    background-position: -2.54rem -0.1rem;
  }
  i.i4{
    width: 0.61rem;
    height: 0.94rem;
    background-position: -0.1rem -2.46rem;
  }
  i.i5{
    width: 1.03rem;
    height: 0.94rem;
    background-position: -0.1rem -0.1rem;
  }
  i.i6{
    width: 0.82rem;
    height: 0.9rem;
    background-position: -3.55rem -0.1rem;
  }
  i.i7{
    width: 0.81rem;
    height: 1rem;
    background-position: -1.13rem -1.24rem;
  }
  i.i8{
    width: 1.01rem;
    height: 0.94rem;
    background-position: -1.33rem -0.1rem;
  }
  i.i9{
    width: 0.81rem;
    height: 0.91rem;
    background-position: -3.55rem -1.2rem;
  }
  .item_img.sp{
    height: 0.62rem;
  }
  .item_img.sp.sp2{
    height: 0.72rem;
  }
  .item_img.sp+p.sp{
    font-size: 0.1637rem;
    line-height: 0.2rem;
  }
  .menu_item p{
    font-size: 0.2rem;
    color: #414042;
    line-height: 0.24rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/index.vue